namespace app.configuracoes {
    "use strict";
    import ITranslatePartialLoaderProvider = angular.translate.ITranslatePartialLoaderProvider;
    import IStateProvider = angular.ui.IStateProvider;

    /** @ngInject **/
    function config($translatePartialLoaderProvider: ITranslatePartialLoaderProvider,
                    $stateProvider: IStateProvider, $futureStateProvider) {

        $translatePartialLoaderProvider.addPart("app/main/configuracoes");

        $stateProvider.state("app.configuracoes", {
            abstract : true,
            url : "/configuracoes",
            parent : "app.autenticado"
        });

        $futureStateProvider.addResolve(/** @ngInject **/ ($q, $injector: ng.auto.IInjectorService, $rootScope,
                configuracoesService: ConfiguracoesService) => {
            let deferredConfigurationsLoading = $q.defer();
            
            function loadFutureConfigurations() {
                configuracoesService.carregarConfiguracoes().then((configurations) => {
                    for (let configuration of configurations) {
                        $futureStateProvider.futureState({
                            type: "load",
                            stateName: configuration.stateName,
                            url: configuration.url,
                            src: configuration.src
                        });
                    }
                    deferredConfigurationsLoading.resolve();
                }, () => {
                    deferredConfigurationsLoading.reject();
                });
            }
            loadFutureConfigurations();
            $rootScope.$on("user:logged", () => {
                configuracoesService.resetConfiguracoes();
                loadFutureConfigurations();
            });
            $rootScope.$on("user:exited", () => {
                configuracoesService.resetConfiguracoes();
            });
            
            return deferredConfigurationsLoading.promise;
        });
    }

    function run(stfBreadcrumbsService: app.support.StfBreadcrumbsService) {
        stfBreadcrumbsService.registerPath({
            id: "configuracoes",
            translation: "Configurações",
            uisref: "app.configuracoes"
        });
    }
    run.$inject = ["stfBreadcrumbsService"];

    angular
        .module("app.configuracoes", ["app.autenticado", "app.support", "app.toolbar"])
        .config(config)
        .run(run);
}